/* tslint:disable */
import {
  Patient
} from '../index';

declare var Object: any;
export interface ClinicInterface {
  "name": string;
  "deleted"?: boolean;
  "id"?: any;
  patients?: Patient[];
}

export class Clinic implements ClinicInterface {
  "name": string;
  "deleted": boolean;
  "id": any;
  patients: Patient[];
  constructor(data?: ClinicInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Clinic`.
   */
  public static getModelName() {
    return "Clinic";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Clinic for dynamic purposes.
  **/
  public static factory(data: ClinicInterface): Clinic{
    return new Clinic(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Clinic',
      plural: 'Clinics',
      path: 'Clinics',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "deleted": {
          name: 'deleted',
          type: 'boolean',
          default: false
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        patients: {
          name: 'patients',
          type: 'Patient[]',
          model: 'Patient',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'referredById'
        },
      }
    }
  }
}
